var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7118 -1.55023e-07C14.1723 -1.49151e-07 13.655 0.197522 13.2735 0.549114C12.8921 0.900705 12.6778 1.37757 12.6778 1.87479L12.6778 23.5961L3.94804 15.5458C3.56612 15.1937 3.04812 14.996 2.508 14.996C1.96787 14.996 1.44988 15.1937 1.06795 15.5458C0.686029 15.8978 0.471466 16.3753 0.471466 16.8731C0.471466 17.371 0.686029 17.8484 1.06795 18.2005L13.2717 29.4492C13.4606 29.6238 13.6851 29.7623 13.9322 29.8568C14.1793 29.9513 14.4442 30 14.7118 30C14.9793 30 15.2442 29.9513 15.4913 29.8568C15.7384 29.7623 15.9629 29.6238 16.1518 29.4492L28.3555 18.2005C28.7375 17.8484 28.952 17.371 28.952 16.8731C28.952 16.3753 28.7375 15.8978 28.3555 15.5458C27.9736 15.1937 27.4556 14.996 26.9155 14.996C26.3754 14.996 25.8574 15.1937 25.4755 15.5458L16.7457 23.5961L16.7457 1.87479C16.7457 1.37756 16.5314 0.900705 16.15 0.549114C15.7685 0.197522 15.2512 -1.60896e-07 14.7118 -1.55023e-07Z",
    fill: "#CB998D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.11bfda4301177c933cd141de77c1e502.svg";
export { ForwardRef as ReactComponent };